module.exports = __webpack_public_path__ + "static/media/Crabominable_gaussian2.c7498aab.png";